import { calculateTotal } from "../moduleSelectionHelpers";

const BillingSummary = ({ modules = [], selectedBaseModules = [] }) => {
  const total = calculateTotal(selectedBaseModules);
  return (
    <div>
      <div className="sticky top-5 rounded-2xl border border-slate-200 dark:border-slate-700 bg-gradient-to-br from-white to-slate-100 dark:from-slate-900 dark:to-slate-950 p-6">
        <h4 className="text-xl font-bold text-slate-900 dark:text-slate-400 mb-5">
          Billing Summary
        </h4>

        <div className="space-y-3">
          {selectedBaseModules.map((baseModule) => {
            const originalBase = modules.find(
              (m) =>
                String(m.baseModuleId) === String(baseModule.BASEMODULE_ID),
            );

            if (!originalBase) return null;

            return (
              <div
                key={originalBase.baseModuleId}
                className="flex items-center justify-between"
              >
                <span className="text-slate-900 dark:text-slate-300 text-sm">
                  {originalBase.baseModuleName}
                </span>

                <span className="text-slate-900 dark:text-slate-400 font-medium">
                  ${originalBase.baseModuleBasePrice}
                </span>
              </div>
            );
          })}
        </div>

        <div className="my-5 border-t border-slate-700" />

        <div className="flex items-center justify-between">
          <span className="text-slate-9000 dark:text-slate-400">
            Total Monthly
          </span>

          <span className="text-3xl font-bold text-teal-400">
            ${total.toFixed(2)}
          </span>
        </div>

        <p className="text-xs text-slate-900 dark:text-slate-500 mt-4 leading-relaxed">
          Pricing updates automatically based on selected modules, child
          modules, and submodules.
        </p>
      </div>
    </div>
  );
};

export default BillingSummary;
